import { environment } from '../../../environments/environment';
import { InjectionToken } from '@angular/core';

export interface FrontendBuild { id: string; }

// Evaluated before main.ts fetches and merges runtime configuration.
export const FRONTEND_BUILD = Object.freeze({
  id: environment.frontendBuildId
});

export const FRONTEND_BUILD_OPTIONS = new InjectionToken<FrontendBuild>('Compiled frontend build', {
  providedIn: 'root', factory: () => FRONTEND_BUILD
});

export function isAppVersion(value: unknown): value is string {
  return typeof value === 'string' &&
    value.trim() === value &&
    /^[A-Za-z0-9][A-Za-z0-9._+-]{0,127}$/.test(value) &&
    !/^(unknown|undefined|null|placeholder)$/i.test(value);
}

export function isConfirmedBuildMismatch(clientId: string, response: unknown): boolean {
  if (!response || typeof response !== 'object' || Array.isArray(response)) { return false; }
  const release = response as { version?: unknown };
  return isAppVersion(clientId) && isAppVersion(release.version) && release.version !== clientId;
}

export function isBuildSetting(key: string): boolean {
  return key.toLowerCase() === 'frontendbuildid';
}
